import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { ComparisonTemplateForm } from "@/features/comparison-templates/ComparisonTemplateForm";
import { useComparisonTemplate } from "@/features/comparison-templates/api";

export const Route = createFileRoute("/_authenticated/quotation-comparison-templates/$templateId")({
  component: EditComparisonTemplate,
});

function EditComparisonTemplate() {
  const { templateId } = Route.useParams();
  const { data, isLoading } = useComparisonTemplate(templateId);
  if (isLoading) return <div className="grid place-items-center p-10"><Loader2 className="h-5 w-5 animate-spin" /></div>;
  if (!data) return <div className="p-6 text-sm text-muted-foreground">Template not found.</div>;
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">Edit Comparison Template: {data.name}</h1>
      <ComparisonTemplateForm initial={data} />
    </div>
  );
}
